import { type ISbStories, type ISbStory } from "@storyblok/react"
import { type SbStoriesParams, type SbStoryParams, type SbStoryReturnType } from "../types"
import { getResolveRelations } from "../utils/getResolveRelations"
import { getSbApi } from "./initStoryblok"
import { type SbLinkResponse, type SbLinksParams } from "./types"

const DEFAULT_RESOLVE_LINKS = "url"

export async function fetchSbLinks(params?: SbLinksParams) {
    const response = (await getSbApi().get(`cdn/links`, {
        ...params,
        // Callers resolving links for draft content need to opt into "draft",
        // otherwise a story that has never been published is missing from the
        // table and cannot be resolved.
        version: params?.version ?? "published",
    })) as SbLinkResponse

    return Object.values(response.data.links)
}

export async function fetchSbStory<TContentType extends string>(
    slug: string,
    params?: SbStoryParams<TContentType>
) {
    const response = (await getSbApi().get(`cdn/stories/${slug}`, {
        ...params,
        resolve_relations: getResolveRelations(params?.resolve_relations),
        resolve_links: params?.resolve_links ?? DEFAULT_RESOLVE_LINKS,
    })) as ISbStory

    return response.data.story as SbStoryReturnType<TContentType>
}

export async function fetchSbStories<TContentType extends string>(
    params: SbStoriesParams<TContentType>
) {
    const response = (await getSbApi().get(`cdn/stories`, {
        ...params,
        resolve_relations: getResolveRelations(params?.resolve_relations),
        resolve_links: params?.resolve_links ?? DEFAULT_RESOLVE_LINKS,
    })) as ISbStories

    return response.data.stories as Array<SbStoryReturnType<TContentType>>
}
